import { createSlice } from "@reduxjs/toolkit";
import KullaniciPrinterDTO from "src/models/Printer/KullaniciPrinterDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { PrinterApi } from "src/services/Printer/PrinterApi";

export interface PrinterState {
  appVersion: number,
  defaultPrinter: string,
  ipAddress: string,
  macAddress: string,
  pcName: string,
  printers: [],
  status: number,
  statustext: string,
  kullaniciPrinter: KullaniciPrinterDTO
}
const PrinterSlice = createSlice<PrinterState, MapReducerPayloads<PrinterState, {
  setState: PrinterState
}>>({
  name: 'print',
  initialState: {
    appVersion: null,
    defaultPrinter: "Printer Seçin",
    ipAddress: "",
    macAddress: "",
    pcName: "",
    printers: [],
    status: 0,
    statustext: "",
    kullaniciPrinter: null
  },
  reducers: {
    setState: (state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addMatcher(PrinterApi.endpoints.getPcInfo.matchFulfilled, (state, action) => {
      state = action.payload
    })
    builder.addMatcher(PrinterApi.endpoints.getKullaniciPrinter.matchFulfilled, (state, action) => {
      state.kullaniciPrinter = action.payload?.length > 0 ? action.payload[0] : null
    })
  }
})
export default PrinterSlice;